import request from "../Utils/Request";

export function putData(url: string, data: any) {
  return request.put(url, data);
}
